import React from 'react';
import { IIconProps } from '../interfaces';

const AleaArrowLeftIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '50',
}) => {
  const width = parseInt(String(size), 10);
  const height = (9 / 12) * width;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 12 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0.892097 4.6934C0.696835 4.49814 0.696835 4.18155 0.892097 3.98629L4.07403 0.80431C4.26929 0.609048 4.58588 0.609048 4.78114 0.80431C4.9764 0.999572 4.9764 1.31615 4.78114 1.51142L1.9527 4.33984L4.78114 7.16827C4.9764 7.36353 4.9764 7.68012 4.78114 7.87538C4.58588 8.07064 4.26929 8.07064 4.07403 7.87538L0.892097 4.6934ZM11.2456 4.33984V4.83984H1.24561V4.33984V3.83984H11.2456V4.33984Z" 
        fill={color}
      />
    </svg>
  );
};

export default AleaArrowLeftIcon;